<template>
  <div class='main'>
    <div class="main_top">
      <div>
        <!-- <el-input
        class="search"
        placeholder="请输入内容"
        v-model="userSearch"
        clearable
        size="small"
        @change="SearchChange"
      >
      </el-input> -->
      </div>
      <div>
        <Button
          icon="md-add"
          @click="addEva('新增')"
        >
          新增
        </Button>
        <Button
          icon="ios-create"
          @click="addEva('编辑')"
        >
          编辑
        </Button>
        <Button
          icon="md-trash"
          @click="deluser"
        >
          删除
        </Button>
      </div>
      <Modal
        v-model="modal1"
        title="保存参数"
        footer-hide
        :draggable='true'
      >
        <el-form
          :model="formInline"
          :rules="ruleInline"
          ref="formInline"
          label-width="120px"
          stripe
          class="demo-formInline"
        >
          <el-form-item
            label="标题"
            prop="newstitle"
          >
            <el-input v-model="formInline.newstitle"></el-input>
          </el-form-item>
          <el-form-item
            label="内容"
            prop="newscontent"
          >
            <el-input
              v-model="formInline.newscontent"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否置顶">
            <el-switch
              v-model="formInline.istop"
              active-text="是"
              inactive-text="否"
              style="margin-left:40px"
            >
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSubmit('formInline')"
            >提交</el-button>
          </el-form-item>
        </el-form>
      </Modal>
    </div>
    <div class="main_body">
      <el-table
        ref="singleTable"
        :data="newDataList"
        highlight-current-row
        @current-change="newChange"
        style="width: 100%"
        tooltip-effect="dark"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="newstitle"
          label="新闻标题"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="createdate"
          label="发布日期"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="username"
          label="发布用户"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column
          property="forwardcount"
          label="转发数量"
          align="center"
          width="150"
        >
        </el-table-column>
        <el-table-column
          property="trumbcount"
          label="点赞数量"
          align="center"
          width="150"
        >
        </el-table-column>
      </el-table>

      <div>
        <el-pagination
          style="text-align:right;margin-top:20px;"
          :hide-on-single-page="true"
          :total="total"
          :page-size="pagesize"
          :current-page='currentpage'
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      modal1: false,
      diatitle: '',
      userSearch: '',
      newDataList: [],
      total: 1,//分页总条数
      pagesize: 13,//每页显示数
      currentpage: 1,//当前页
      newsItem: {},//用户选中项
      evaNameList: [],//参数名称列表
      formInline: {
        newstitle: '',
        newscontent: '',
        newstype: 1,
        istop: false,
        isshowgateway: '1'
      },
      ruleInline: {
        newstitle: [
          { required: true, message: '请输入标题!', trigger: 'blur' }
        ],
        newscontent: [
          { required: true, message: '请输入内容!', trigger: 'blur' },
        ],
      }
    }
  },
  created () {
    this.GetDataList()
  },
  methods: {
    //搜索
    SearchChange (val) {
      console.log(val);
    },
    //用户表格选中项
    newChange (val) {
      this.newsItem = val
    },

    //获取公告列表
    async GetDataList () {
      const req = await Api.baseNewsinfo.GetDataList(1, this.currentpage, this.pagesize)
      if (req.success != true) return this.$Message.info(req.msg)
      this.newDataList = req.rows
    },
    handleCurrentChange (val) {
      this.currentpage = val;
      this.GetEvaDataList()
    },
    //新增编辑参数
    async addEva (msg) {
      if (msg == '编辑') {
        if (JSON.stringify(this.newsItem) == '{}') return this.$Message.info('请选择要编辑的参数！')
        this.formInline.newsid = this.newsItem.newsid
        this.formInline = this.newsItem
        if (this.formInline.istop == '是') {
          this.formInline.istop = 1
        } else {
          this.formInline.istop = 0
        }
      }
      this.modal1 = true
    },
    handleSubmit (name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          if (this.formInline.istop) {
            this.formInline.istop = 1
          } else {
            this.formInline.istop = 0
          }
          const res = await Api.baseNewsinfo.SaveData(this.formInline)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          this.modal1 = false
          this.GetDataList()
        } else {
        }
      })
    },
    //删除用户
    async deluser () {
      if (JSON.stringify(this.newsItem) == '{}') return this.$Message.info('请选择要删除的新闻！')
      this.$confirm('此操作将永久删除该新闻, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await Api.baseNewsinfo.DelData([this.newsItem.newsid])
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.GetDataList();
        }
        this.GetSchoolTreeList()
      }).catch(() => {

      });
    },

  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    .dropdown {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      line-height: 1.5;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      height: 32px;
      line-height: 29px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      transition: color 0.2s linear, background-color 0.2s linear,
        border 0.2s linear, box-shadow 0.2s linear;
      color: #515a6e;
      background-color: #fff;
      border-color: #dcdee2;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
}
</style>